module.exports = __webpack_public_path__ + "img/edifier-logo.6a58113c.svg";